module.exports = __webpack_public_path__ + "img/Pic_XYZX_ZH_Half.5856dbc0.png";